export default __webpack_public_path__ + "static/media/SideImage.b07cfe1f.jpg";